import React from "react";
import "./PremiumServices.css";
import { FaChevronRight } from "react-icons/fa";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const services = [
  {
    title: "Strength & Conditioning",
    image: require("../assets/Premium-1.jpg"),
    description:
      "Unlock peak athletic performance with our expert-led Strength & Conditioning services. Designed for athletes of all levels, our programs focus on enhancing strength, speed, endurance, and injury resilience through science-backed training. Whether you're preparing for competition or looking to elevate your fitness, our qualified coaches and sports scientists deliver personalized plans tailored to your goals. Train smarter. Perform better.",
  },
  {
    title: "Injury Rehabilitation",
    image: require("../assets/Premium-2.jpg"),
    description:
      "Our Injury Rehabilitation services at the Sports Science Center provide expert care and personalized recovery plans for athletes and active individuals. Combining advanced physiotherapy, sports medicine, and performance tracking, we help you recover safely and return stronger. Whether you're healing from a sprain, muscle strain, or post-surgery, our team is here to support every step of your rehabilitation journey.",
  },
  {
    title: "Nutrition Services",
    image: require("../assets/Premium-5a.png"),
    description:
      "Our Nutrition Services provide expert guidance in both clinical and sports nutrition, tailored to support optimal health, performance, and recovery. Whether you're an athlete aiming to enhance performance or an individual managing a medical condition, our team of qualified nutritionists offers personalized plans based on scientific evidence. We bridge the gap between health and performance through comprehensive assessments, dietary strategies, and ongoing support to help you achieve your goals.",
  },
  {
    title: "Sports Psychology",
    image: require("../assets/Premium-4.jpg"),
    description:
      "Unlock peak performance through the power of the mind. Our Sports Psychology division helps athletes enhance focus, build mental resilience, manage stress, and maintain motivation. Through personalized mental training, performance coaching, and psychological assessments, we support athletes in achieving their full potential—on and off the field.",
  },
  {
    title: "Group Fitness Classes",
    image: require("../assets/Premium-3a.jpg"),
    description:
      "Energize your workout with our expert-led Group Fitness Classes, designed for all fitness levels. From high-intensity interval training (HIIT) to yoga, strength training, and functional mobility, our science-backed classes combine motivation, community, and performance tracking to help you reach your fitness goals safely and effectively. Join a supportive environment where movement meets science.",
  },
  {
    title: "Sports Science Assessment",
    image: require("../assets/Premium-6.jpg"),
    description:
      "Unlock peak performance with our Sports Science Assessment services. At our state-of-the-art Sports Science Center, we offer comprehensive evaluations to measure athletic ability, physical fitness, biomechanics, and injury risks. Using advanced tools and expert analysis, we provide personalized insights to optimize training, enhance recovery, and improve overall athletic performance. Ideal for athletes, coaches, and fitness enthusiasts striving for scientific precision in sports development.",
  },
];

const serviceSchema = {
  "@context": "https://schema.org",
  "@type": "ItemList",
  "name": "Premium Fitness Services",
  "itemListElement": services.map((service, index) => ({
    "@type": "Service",
    "position": index + 1,
    "name": service.title,
    "provider": {
      "@type": "Organization",
      "name": "Aikyam Sports Science"
    }
  }))
};

const PremiumServices = () => {
  return (
      <>
  <Helmet>
    <script type="application/ld+json">
      {JSON.stringify(serviceSchema)}
    </script>
  </Helmet>
    <section className="premium-section" id="premium-services">
      <h2 className="premium-title">Premium Fitness Services</h2>
      <p className="premium-subtitle">
        Tailored Workouts, Expert Guidance, and Comprehensive Programs to Meet All Your Fitness Needs
      </p>

      <div className="card-grid">
        {services.map((service, index) => (
          <Link to="/fitness" className="link-no-underline">
          <article className="service-card" key={index}>
            <img src={service.image} alt={`${service.title} at Aikyam Sports Science`}/>
            <h4>{service.title}</h4>
            <p>{service.description}</p>
            <button>Learn More</button>

            
          </article>
          </Link>
        ))}
      </div>
      <div className="more-button-wrapper">
        <Link to="/fitness" className="link-no-underline">
        <button className="more-button">
          More <FaChevronRight />
        </button>
        </Link>
      </div>
    </section>
    </>
  );
};

export default PremiumServices;
